/**
 * 地図描画のエラーバウンダリ
 *
 * APIキーの認証失敗（RefererNotAllowedMapError 等）で marker ライブラリが読み込めないと
 * AdvancedMarker が例外を投げてページ全体が落ちるため、地図の領域だけで食い止める。
 */

import { Component, type CSSProperties, type ErrorInfo, type ReactNode } from 'react'

type MapErrorBoundaryProps = {
  className?: string
  style?: CSSProperties
  children: ReactNode
}

type MapErrorBoundaryState = {
  hasError: boolean
}

export class MapErrorBoundary extends Component<MapErrorBoundaryProps, MapErrorBoundaryState> {
  state: MapErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): MapErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('[Map] 地図の描画に失敗しました', error, errorInfo.componentStack)
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children

    return (
      <div className={this.props.className} style={this.props.style}>
        <div className="text-muted-foreground bg-muted flex h-full w-full flex-col items-center justify-center gap-1 p-4 text-center text-sm">
          <span>地図を表示できませんでした</span>
          <span className="text-xs">APIキーの制限設定を確認してください</span>
        </div>
      </div>
    )
  }
}
